<template>
  <div id="app" >
    <!-- <el-container>
      <el-header>
        <my-nav></my-nav>
      </el-header>
      <el-main>
        <router-view class="view"/>
      </el-main>
    </el-container> -->
    <my-nav></my-nav>
    <router-view class="view"/>
    
    <login-modal v-if="showLogin"></login-modal>
     <!-- <my-footer></my-footer> -->
     <div v-if="showLogin" class="modal-backdrop fade in shadowbox"></div>
     <!-- <div :class="[msg.type=='error'?'errorLine':'successLine']">{{msg.text}}</div> -->
      <div id="toast-container" class="toast-bottom-right" aria-live="polite" role="alert" v-if="msg.text">
      <div  :class="[{ 'toast-error': msg.type=='error' }, { 'toast-success': msg.type=='success' },'toast']" style="">
        <div class="toast-title">提示</div>
        <div class="toast-message">{{msg.text}}</div>
        </div>
      </div>
  </div>
</template>

<script>
import MyNav from './layout/MyNav'
import LoginModal from './layout/LoginModal'
//import MyFooter from './layout/MyFooter';
export default {
  name: 'app',
  components: {
    MyNav,
    LoginModal,
    //MyFooter
  },
  created(){
     
  },
  computed:{
      showLogin(){
        return this.$store.state.showLogin;
      },
      msg(){
        return this.$store.state.errormsg;
      },
      
  }
}
</script>

<style>
body{
  margin: 0 !important;
  padding: 0 !important;
}

</style>
